module.exports = __webpack_public_path__ + "static/media/cardImg.e8057a23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cardImg.png
// module id = 1014
// module chunks = 2